import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!username || !password || !role) {
            alert('Please fill in all fields and select a role.');
            return;
        }

        try {
            console.log(`Attempting login for username: ${username} and role: ${role}`);

            const response = await axios.post('http://127.0.0.1:5000/auth/login', {
                username,
                password,
            });

            console.log('Login response:', response.data);

            if (response.status === 200) {
                const { username, role, jobseeker_id, full_name, employer_id, company_name } = response.data;

                // Store login data in localStorage
                localStorage.setItem('username', username);
                localStorage.setItem('role', role);
                
                if (role === 'jobseeker') {
                    localStorage.setItem('jobseeker_id', jobseeker_id);
                    localStorage.setItem('full_name', full_name);
                    navigate('/jobseeker-dashboard');
                } else if (role === 'employer') {
                    localStorage.setItem('employer_id', employer_id);
                    localStorage.setItem('company_name', company_name);
                    navigate('/dashboard');
                }
            }
        } catch (error) {
            console.error('Login failed:', error.response?.data || error.message);
            alert(error.response?.data?.error || 'Login failed. Please try again.');
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
            <h2>Login</h2>
            <form onSubmit={handleLogin}>
                <div style={{ marginBottom: '15px' }}>
                    <label>
                        <input
                            type="radio"
                            name="role"
                            value="employer"
                            onChange={(e) => setRole(e.target.value)}
                        />
                        Employer
                    </label>
                    <label style={{ marginLeft: '10px' }}>
                        <input
                            type="radio"
                            name="role"
                            value="jobseeker"
                            onChange={(e) => setRole(e.target.value)}
                        />
                        Job Seeker
                    </label>
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        style={{ width: '100%', padding: '10px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{ width: '100%', padding: '10px' }}
                    />
                </div>
                <button
                    type="submit"
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#007BFF',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Login
                </button>
            </form>
        </div>
    );
};

export default Login;

